import { useNavigate } from "@solidjs/router";
import { onCleanup, onMount } from "solid-js";
import { ongoingTrip } from "./ongoing";
import { session } from "./session";

/** On arrival on a screen: a ride in progress takes over (unless the rider left meanwhile). */
export function useResumeOngoingTrip() {
  const navigate = useNavigate();
  let left = false;
  onCleanup(() => {
    left = true;
  });
  onMount(async () => {
    const trip = await ongoingTrip(await session.known());
    if (trip && !left) navigate("/ride", { replace: true });
  });
}
